import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { usePaymentsUIContext } from '../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import { usePaymentMethodLabelsMap } from '../../hooks/use-payment-method-labels-map.js';
import '../../models/adyen/payment-type.js';
import { PaymentMethod, PaymentServiceProvider } from '../../models/cart-payment-methods/cart-payment-methods.js';
import '../../models/googlePay/types.js';
import '../../models/payment/types.js';
import '../../models/paypal/context.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/graphql';
import '@grandvisionhq/icons';
import '../../operations/queries/get-cart-payment-methods.js';
import '../../operations/queries/get-cart-express-payment-methods.js';
import '../../operations/queries/get-payment-status-by-token.js';
import { ApplePayButton } from '../../modules/ExpressPaymentMethods/ApplePay/ApplePayButton.js';
import { AdyenPaypalActionButton } from '../../modules/ExpressPaymentMethods/Paypal/AdyenPaypalActionButton/AdyenPaypalActionButton.js';
import '../../operations/mutations/initiate-paypal-transaction.js';
import { PaypalActionButtonContainer } from '../../modules/ExpressPaymentMethods/Paypal/PaypalActionButton/PaypalActionButtonContainer.js';
import { DonationFormComponent } from '../DonationFormComponent/DonationFormComponent.js';

const PaymentForm = ({ paymentMethod , paymentProvider , form , onHandlePaymentAction , donations , selectedDonation , onDonationSelected , totalPrice  })=>{
    const { getLabel , hasLabel , locale , currency  } = useIntl();
    const { actionLabels  } = usePaymentMethodLabelsMap();
    const breakPoint = MediaQuery.useBreakpoint();
    const { isProcessingOrder , currentCardBrand  } = usePaymentsUIContext();
    const [enableWaitText, setEnableWaitText] = React.useState(false);
    React.useEffect(()=>{
        if (isProcessingOrder) {
            const timeoutId = setTimeout(()=>{
                setEnableWaitText(true);
            }, 3000);
            return ()=>clearTimeout(timeoutId)
            ;
        } else {
            setEnableWaitText(false);
        }
    }, [
        isProcessingOrder
    ]);
    const actionButton = React.useMemo(()=>{
        switch(paymentMethod){
            case PaymentMethod.APPLE_PAY:
                return /*#__PURE__*/ React.createElement(ApplePayButton, {
                    type: "regular-checkout",
                    onClick: onHandlePaymentAction,
                    disabled: isProcessingOrder
                });
            case PaymentMethod.PAYPAL:
                return paymentProvider === PaymentServiceProvider.ADYEN ? /*#__PURE__*/ React.createElement(AdyenPaypalActionButton, {
                    onClick: onHandlePaymentAction,
                    disabled: isProcessingOrder
                }) : /*#__PURE__*/ React.createElement(PaypalActionButtonContainer, {
                    disabled: isProcessingOrder
                });
            case PaymentMethod.GOOGLE_PAY:
                return null;
            default:
                return /*#__PURE__*/ React.createElement(Button, {
                    color: "primary",
                    size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
                    caption: `${getLabel(`checkout.action.pay.continueWith`)} ${actionLabels[paymentMethod]} (${formatPrice({
                        locale,
                        value: (totalPrice !== null && totalPrice !== void 0 ? totalPrice : 0) + (selectedDonation !== null && selectedDonation !== void 0 ? selectedDonation : 0),
                        currency,
                        isCentAmount: true
                    })})`,
                    "data-t": `button-next-payment`,
                    disabled: isProcessingOrder,
                    onClick: onHandlePaymentAction,
                    isLoading: isProcessingOrder
                });
        }
    }, [
        paymentMethod,
        onHandlePaymentAction,
        isProcessingOrder,
        paymentProvider,
        breakPoint,
        getLabel,
        actionLabels,
        locale,
        totalPrice,
        selectedDonation,
        currency, 
    ]);
    const handleDonationSelected = React.useCallback((foundationKey, amount)=>{
        onDonationSelected && onDonationSelected({
            paymentMethod,
            foundationKey,
            amount
        });
    }, [
        onDonationSelected,
        paymentMethod
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "payment-form-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "payment-form-container__form"
    }, form && form), actionButton, hasLabel(`checkout.${paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toLowerCase()}.instruction`) && /*#__PURE__*/ React.createElement(Text, {
        className: "payment-form-container__instruction"
    }, getLabel(`checkout.${paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toLowerCase()}.instruction`)), enableWaitText && /*#__PURE__*/ React.createElement(Text, {
        className: "payment-form-container__instruction"
    }, getLabel(`checkout.payment.wait.instruction`)), donations === null || donations === void 0 ? void 0 : donations.map((donation, index)=>{
         return React.createElement(DonationFormComponent, swcHelpers.extends({
            foundationKey: donation.key,
            key: index,
            name: `${paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toLowerCase()}-donations`,
            options: donation.options,
            onClick: handleDonationSelected
        }, currentCardBrand && (donation === null || donation === void 0 ? void 0 : donation.brands) && {
            brandIsNotSupportedForDonation: !donation.brands.includes(currentCardBrand)
        }, selectedDonation && {
            initialValue: selectedDonation
        }));
    }));
};

export { PaymentForm };
//# sourceMappingURL=PaymentForm.js.map
